let validaCPF = (cpf) => {

    let numeros, digitos, soma, i, resultado, filtro = cpf;

    filtro = filtro.replace(/\./g, "");
    filtro = filtro.replace(/\-/g, "");

    if (cpf.length == 0) {
        return false;
    }

    if ((filtro.length > 0 && filtro.length < 11) || filtro == "00000000000" || filtro == "11111111111" || filtro == "22222222222" || filtro == "33333333333" || filtro == "44444444444" || filtro == "55555555555" || filtro == "66666666666" || filtro == "77777777777" || filtro == "88888888888" || filtro == "99999999999") {
        window.swal('Aviso!', 'CPF inválido. Tente novamente.', 'info');
        return false;
    }

    numeros = filtro.substring(0, 9);
    digitos = filtro.substring(9);
    soma = 0;
    for (i = 10; i > 1; i--)
        soma += numeros.charAt(10 - i) * i;
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
        window.swal('Aviso!', 'CPF inválido. Tente novamente.', 'info');
        return false;
    }
    numeros = filtro.substring(0, 10);
    soma = 0;
    for (i = 11; i > 1; i--)
        soma += numeros.charAt(11 - i) * i;
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
        window.swal('Aviso!', 'CPF inválido. Tente novamente.', 'info');
        return false;
    }
    return true;
};

let validaCNPJ = (cnpj) => {

    let numeros, digitos, soma, i, resultado, pos, tamanho, filtro = cnpj;

    filtro = filtro.replace(/\./g, "");
    filtro = filtro.replace(/\//g, "");
    filtro = filtro.replace(/\-/g, "");

    if (cnpj.length == 0) {
        return false;
    }
    if (filtro.length != 14 || filtro == "00000000000000" || filtro == "11111111111111" || filtro == "22222222222222" || filtro == "33333333333333" || filtro == "44444444444444" || filtro == "55555555555555" || filtro == "66666666666666" || filtro == "77777777777777" || filtro == "88888888888888" || filtro == "99999999999999") {
        window.swal('Aviso!', 'CNPJ inválido. Tente novamente.', 'info');
        return false;
    }

    tamanho = filtro.length - 2;
    numeros = filtro.substring(0, tamanho);
    digitos = filtro.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
        window.swal('Aviso!', 'CNPJ inválido. Tente novamente.', 'info');
        return false;
    }
    tamanho = tamanho + 1;
    numeros = filtro.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
        window.swal('Aviso!', 'CNPJ inválido. Tente novamente.', 'info');
        return false;
    }
    return true;
};

let consultaCep = async (cep, http) => {
    
    if (cep == '' || cep == undefined) {
        window.swal('Aviso!', 'O campo CEP não foi informado.', 'info');
        return null;
    }
    
    cep = cep.replace('.', '').replace('-', '');
    let retorno = null
    await $.getJSON("//viacep.com.br/ws/" + cep + "/json/?callback=?", dados => {
        if (!("erro" in dados)) {
            retorno = dados
        } else {
            window.swal('Aviso!', 'CEP não localizado.', 'info');
        }
    });

    if (retorno != null) {
        await http.post('api/cidades/buscaCodigoIbge', {'codigo_ibge': retorno.ibge}).then(resp => {
            retorno.cidade = resp.data
        })
    }
    return retorno
};

export default {
    validaCNPJ,
    validaCPF,
    consultaCep
}